import {
  pathOr, prop,
} from 'ramda'
import {
  getCustomerLinks,
} from '../../services/apis'
import {
  isServerResponseError,
  hasError,
} from '../common'

const getLinksData = async (id, page, limit) => {
  const result = await getCustomerLinks(id, page, limit)
  return isServerResponseError(result) || hasError(result)
    ? {
      total: 0,
      data: []
    }
    : prop('data', result)
}

export default getLinksData